import { render, staticRenderFns } from "./userBind.vue?vue&type=template&id=06c57fab&"
import script from "./userBind.vue?vue&type=script&lang=js&"
export * from "./userBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports